export default {
  geelyFintech: '盛宝金融科技',
  pageHeader: '盛宝金融科技有限公司',
  homePage: '首页',
  aboutUs: '关于我们',
  aboutFintech: '关于我们',
  aboutUs_1: '集团介绍',
  aboutUs_2: '新闻资讯',
  joinUs: '加入我们',
  joinUs_1: '社会招聘',
  joinUs_2: '校园招聘',
  homePageJoin_1: '社会招聘',
  homePageJoin_2: '校园招聘',
  contactUs: '联系我们',
  careers: '虚位以待',
  news: "新闻资讯",
  homePageTitle: '集以成以利天下',
  homePageFirst: '全球的金融科技领导者',
  homePageSecond: '金融监管科技专家',
  aboutUsContentShort: '我们致力于引入全球领先的金融科技技术，助力中国金融机构 持续创新发展。',
  aboutGeelyFintech: '关于盛宝金融科技',
  headquater: `重庆总部 /`,
  phone: '联系电话',
  email: 'Email',
  aboutGeelyFintechContents: [
    '盛宝金融科技有限公司（以下简称“盛宝金科”）于2020年6月落户重庆两江新区，同年11月开始正式运营。2023年下半年，盛宝金科已正式成为吉利控股集团全资子公司。',
    '盛宝金科持续在金融科技行业深耕，坚持守正创新，多次获得相关权威认证和奖项，为企业发展注入澎湃动力。',
    {
      name: 'milestone',
      type: 'list',
      value: [
        '2023年成功通过高新技术企业认定',
        '2023年荣登由重庆市经信委公布的 “专精特新“企业名单',
        '2023年荣获由两江新区管委会颁布的重庆市 “智汇两江·十大科技创新企业”称号',
        '2023年荣获重庆国金认证“金融科技服务综合能力AAA级评价”',
        '22022年度信创应用创新奖',
        '2022年度新锐金融科技企业',
        '2022信创产业独角兽TOP100',
        '……'
      ]
    },
    '盛宝金科立志成为拥有全球领先金融科技技术且100%自主知识产权的金融科技公司，对标国际最先进技术，填补国内金融科技空白，提供全方位的监管科技、资产管理、产业金融、场景金融、绿色金融等解决方案，为国内金融机构迎接开放保驾护航。'
  ],
  aboutGeelyGroup: '关于吉利控股集团',
  aboutGeelyGroupContents: [

    `浙江吉利控股集团（以下简称“吉利控股集团”）始建于1986年，1997年进入汽车行业，一直专注实业，专注技术创新和人才培养，不断打基础练内功，坚定不移地推动企业转型升级和可持续发展。现资产总值超5100亿元，员工总数超过14万人，连续十二年进入《财富》世界500强（2023年排名225位），是全球汽车品牌组合价值排名前十中唯一的中国汽车集团。`,
    `吉利控股集团在中国上海、杭州、宁波，瑞典哥德堡、英国考文垂、美国加州、德国法兰克福等地建有造型设计和工程研发中心，研发、设计人员超过3万人。在中国、美国、英国、瑞典、比利时、马来西亚建有世界一流的现代化整车和动力总成制造工厂，拥有各类销售网点超过4000家，产品销售及服务网络遍布世界各地。`,
    `吉利控股集团是第19届杭州亚运会官方合作伙伴。吉利汽车启动主题为“科技吉利，悦行亚运”的亚运战略，通过绿色科技、智能科技、人文责任等举措，全方位赋能杭州亚运会。`,
    `吉利控股集团秉承“让世界充满吉利”的使命和“充分授权、依法合规、考核清晰、公平透明”的经营管理方针，长期坚持ESG可持续发展战略，在应对气候变化、资源保护、出行安全、社会责任以及商业道德等领域进行科学治理，带动产业链上下游企业协同发展，助力区域经济均衡发展，为创造超越期待的出行体验、实现中国汽车强国梦而不懈努力!`
  ],
  aboutSAXOBankGroup: '关于盛宝银行集团',
  aboutSAXOBankGroupContents: [

    `盛宝银行集团是领先的金融科技公司，致力于促进广大投资者与全球资本市场的连接。作为多资产交易和投资的全球领导者，
    盛宝的愿景是帮助人们实现财务目标并对自己和所在社区产生积极的影响。`,

    `盛宝银行成立于1992年，并于1998年推出其第一个在线交易平台，是首批推出在线交易平台的金融机构之一。
    该平台赋予了个人投资者与专业交易员、基金经理和大型金融机构同等的专业交易工具。客户的需求是盛宝创新发展的
    动力。目前，全球有170多个国家的个人和机构客户通过盛宝的交易平台从一个保证金账户无缝接入全球资本市场，并可
    灵活切换20多种语言，交易多个资产类别40，000多个金融产品。盛宝银行亦积极参与中国资本市场互联互通渠道设施建
    设，通过股票通和债券通为海外投资者投资中国境内资产提供一站式交易服务。盛宝银行同时还为全球120多家金融机构
    提供开放银行解决方案，帮助这些合作伙伴提升客户交易体验。`,

    `盛宝银行集团总部位于丹麦哥本哈根，客户资产总额超过450亿欧元，并在伦敦、巴黎、苏黎世、迪拜、新加坡、上海、
    香港和东京等世界金融中心设有分支机构并有2100多名金融和科技人员。盛宝银行是受欧盟监管的全牌照银行。`,

    `详情请访问：https://cn.saxobank.com/。`

  ],
  joinUsContents: [{
    prop: 1,
    label: '技术',
    icon: require('@/assets/icon/technical.png'),
    subs: [
      {
        job: '大数据开发工程师',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '负责金融大数据平台的功能组件开发、数据管道搭建等工作',
              '设计稳定、可复用、可扩展的数据仓库模型、用户画像数据模型，快速响应公司决策数据需求、各方向数据分析挖掘需求',
              '治理整合多方、异构数据，合理实现数据中台的数据分层、组织管理等',
              '负责大数据集群的设计、扩容和优化',
              '负责大数据平台自动化工具的设计、开发和优化'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '全日制本科及以上学历',
              '深入理解Linux系统，精于容量规划、架构设计、性能优化，专家优先',
              '具备一定的开发能力，精通一门以上脚本语言(Shell/Perl/Python等)，熟悉Java/Python/Scala/Golang等一种以上语言，熟悉Ansible/Chef/Peppet中一种',
              '熟悉Hadoop 、Spark、Kafka、Airflow等组件的工作原理，并有Hadoop生态系统调优经验',
              '有集群设计、部署和优化经验优先',
              '了解银行金融业务，有金融相关项目经验优先',
              '',
              '请将简历发送到邮箱shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '运维工程师',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '服务器整体调整规划',
              '负责业务系统上线部署，升级调试，优化工作',
              '日常监控、故障处理、日志分析',
              '调整和优化系统、运维架构设计，保障系统运行稳定、及时发现与解决系统问题',
              '配合参与运维规范、运维流程等工作制定'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '本科以上学历，5年以上运维或相关经验',
              '熟悉阿里云、腾讯云等主流云服务商',
              '熟悉Linux，Windows系统，熟悉针对不同应用对应的系统优化',
              '熟悉主流监控工具，zabbix，nagios，cacti，prometheus等等',
              '熟悉自动化运维相关工具， saltstack或者ansible',
              '熟悉nginx、IIS、gitlab、消息队列、elasticsearch，redis等',
              '熟悉docker，有过docker，k8s线上环境维护经验更好',
              '熟悉shell,python,go等语言，必须要一定的脚本编程能力',
              '具有较强的故障排查定位能力、自主学习能力',
              '具备良好的沟通，团队合作能力、文案编写能力及较强的责任心',
              '',
              '请将简历发送到邮箱shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '交易系统高级开发人员',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '3年以上工作经验 •精通C＃和C ++ ',
              '.NET和SQL的工作知识，可将SQL Server用作后端数据库 ',
              '需要能够理解集成点和上游/下游系统',
              '在中国技术或资本市场的工作经验',
              '在中国交易系统方面的经验将是一个巨大优势',
              '良好的沟通能力。熟练的中文和良好的英语能力',
              '拥有数据库性能调优的经验',
              '拥有学习新技术的能力和兴趣，尤其是基于云的技术',
              '对中国证券交易所或期货交易所界面具有深刻理解',
              '',
              '请将简历发送到邮箱shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '资深C#语言开发工程师',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '3年以上工作经验',
              '精通C＃',
              '应该能够理解集成点和上游/下游系统',
              '具备在中国技术或资本市场的工作经验',
              '拥有在中国交易系统方面的经验',
              '拥有良好的沟通能力，英语水平良好',
              '',
              '请将简历发送到邮箱shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '解决方案架构师',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '驱动并审查从前到后解决方案的技术和体系结构设计，同时通过识别受影响的系统，服务和应用程序来增强体系结构准则和系统一致性',
              '确定可行性，并与Tech Lead和SCRUM Master一起负责T-shirt sizing，以优化资源利用',
              '指导技术团队，推动新功能/应用程序与现有系统的集成',
              '与IT和GC管理人员一起定义架构/技术路线图和策略',
              '技术风险承担者，需确保正确解决和缓解风险。在设计方面，对运营和风险管理有很大的下游影响',
              '与基础架构经理合作，以确保将基础架构顺利集成和优化到解决方案设计中',
              '与项目团队合作，确保项目按照组织的发布和配置标准运行',
              '查看供应商建议，并确保供应商的设计/实现符合解决方案设计的接受标准',
              '在澄清要求，针对业务目标和资源/技术约束的解决方案方面，在企业所有者和IT技术团队之间进行推动沟通的进行'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '熟悉Microsoft平台和开发工具',
              '对金融服务中通常使用的技术（包括基础设施）的了解。核心组件了解的深度是一大优点，例如交易系统，后台办公核心组件，API',
              '了解敏捷方法论，以及解决方案体系结构如何与IT保持一致 •事件驱动架构的工作知识',
              '了解软件开发过程，工具和生命周期 •具有发行管理经验和对DevOps的了解者优先',
              '数据架构知识是一大优势',
              '熟悉Azure等常见云平台是一大优势',
              '对企业架构框架（例如TOGAF，Zachman框架，FEAF，NIST等）的知识也非常需要',
              '有说服力和果断性的独立思想家',
              '极富创造力和机智',
              '考虑业务KPI和以客户为中心',
              '能够清楚地交流任何限制，可行性和可用选项',
              '对新技术感到好奇，并继续学习',
              '快速学习。能够高度的理解概念并将其转化为细节的能力',
              '',
              '请将简历发送到邮箱shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '敏捷专家',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '这是一个技术团队的高级职位。他/她在团队中负责运用Scrum和敏捷方法学（agile）解决问题',
              '该职位负责利用Scrum和敏捷方法来推动团队交付',
              '由于该岗位涉及整个技术堆栈和交付过程，因此合适的候选人必须表现出强大的管理技能',
            ]
          },
          {
            title: '任职要求',
            rows: [
              '具有软件开发周期和变更管理周期的经验',
              '掌握Scrum技术和工件',
              '擅长完善，故事拆分，估计，速度，回顾和其他Scrum技术',
              '掌握知识共享和促进技能。敏锐的Scrum方法论老师',
              '掌握金融业的IT系统，平台知识',
              '了解软件质量保证和测试原则和流程',
              '具有与所有利益相关者包括Scrum团队进行熟练有效的沟通的能力',
              '结构一致的方法，例如敏捷的计划，但采用一致的方法，以便为Scrum团队提供稳定性',
              '具有建设性的解决问题和解决冲突的能力',
              '具有在需要时果断的能力。愿意在联合决策过程中拥有所有权或提供专业意见',
              '在具有关注敏捷性的同时，此人也充分注意合规性要求',
              '',
              '请将简历发送到邮箱shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '安卓开发工程师',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '负责公司移动APP前端/原生软件设计与开发',
              '与产品经理和设计师进行充分沟通，根据产品需求设计技术方案',
              '根据技术方案编写高质量的前端代码，进行前后端数据联调，负责研发代码的自测',
              '优化前端页面动态交互，持续改善优化前端性能，提升用户体验',
              '严格遵守团队的代码规范、结构定义，编写易读、易维护、高质量、高效率的代码，保持高效的前端性能'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '具有三年及以上Android开发经验',
              '有扎实的编程功底和编程经验，熟悉Java开发语言',
              '熟悉Android程序设计，了解Android SDK及相关开发工具的使用',
              '熟悉主流的开源组件以及框架，能处理常见大型项目的问题',
              '精通iOS/Android平台下的高性能编程及性能调优，对网络通信、内存管理等有深刻的了解',
              '有金融行业网络金融领域或互联网公司相关工作经验者优先',
              '',
              '请将简历发送到邮箱  shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: 'IOS前端开发工作师',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '负责公司移动APP前端/原生软件设计与开发',
              '与产品经理和设计师进行充分沟通，根据产品需求设计技术方案',
              '根据技术方案编写高质量的前端代码，进行前后端数据联调，负责研发代码的自测',
              '优化前端页面动态交互，持续改善优化前端性能，提升用户体验',
              '严格遵守团队的代码规范、结构定义，编写易读、易维护、高质量、高效率的代码，保持高效的前端性能',
            ]
          },
          {
            title: '任职要求',
            rows: [
              '三年年以上IOS开发经验',
              '具备扎实的Objective C、C/C++ 基础，熟练掌握MacOS操作系统和XCode开发环境',
              '具有一定iPhone系统或苹果软件开发经验，熟练掌握iPhone SDK',
              '熟悉主流的开源组件以及框架，能处理常见大型项目的问题',
              '精通iOS/Android平台下的高性能编程及性能调优，对网络通信、内存管理等有深刻的了解',
              '有金融行业网络金融领域或互联网公司相关工作经验者优先',
              '',
              '请将简历发送到邮箱  shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: 'H5开发工程师',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '参与web前端架构设计与开发',
              '负责小程序的开发和维护',
              '开发交易的web前端、对接行情',
              '负责用户体验的持续优化'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '熟悉使用HTML5，ES5、ES6、 CSS3等移动端web开发技术',
              '熟悉vuejs，nodejs，小程序',
              '熟悉原生JavaScript',
              '熟悉网络协议（HTTP/SSL），对HTTP，TCP/IP有丰富的经验',
              '熟悉掌握 Gulp, Webpack, 对于前端模块化及构建有深入理解',
              '有金融、股票、交易等前端产品开发经验，能够深刻理解相关业务',
              '具有良好的代码风格、接口设计与程序架构意识',
              '对前后端分离有一定的了解',
              '',
              '请将简历发送到邮箱  shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '后端开发工程师',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '负责港美股证券系统的交易、行情、结算系统的开发、维护等工作',
              '负责相关系统的方案设计、开发落地、以及后续维护工作'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '本科及以上学历，计算机或相关专业',
              '对美股或港股的 交易、行情或清结算业务有一定实际经验',
              '有三年以上的开发经验，至少熟悉Java/.Net/Go中的一种',
              '熟悉数据库、缓存、消息队列等基础组件',
              '熟悉 Docker、Kubernetes，微服务治理等',
              '',
              '请将简历发送到邮箱  shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '研发组负责人',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '与项目经理/ IT研发组合作，定义金融科技系统及产品研发路径，将业务需求转化为产品开发的任务',
              '协助IT开发项目规划以及整体项目计划和文档的编制, 协助监管，衡量，审核和更新项目流程，调整项目计划，实施补救计划并通知所有相关方',
              '明确定义项目的交付成果和阶段性里程碑，使用敏捷项目管理方法交付项目和产品，并经常完成迭代',
              '倡导团队合作且灵活的规划，根据团队的生产力和能力来确定需要完成的工作的优先级',
              '通过领导力和榜样激励和培养员工，确定员工的学习和职业发展需求'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '十年以上的IT工作经验，资本市场经验优先',
              '2年以上管理本地或海外团队交付的经验',
              '5年以上敏捷交付管理经验',
              '执行力强，能高质量完成可交付成果',
              '在交付跨职能项目方面具有丰富的经验',
              '有自我驱动力，务实，结果导向，能保证透明度并与所有项目相关者合作',
              '有行业证书优先',
              '',
              '请将简历发送到邮箱  shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '中高级交易连接开发',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '期望经验：5 ~ 10 年',
              'C# 和 数据库经验',
              '具有实时系统中开发项目经验',
              '具有境内外证券、期货、外汇等相关产品交易所系统直连经验',
              '精通 FIX，Open API和其他接口调用',
              '前台交易系统经验优先',
              '',
              '请将简历发送到邮箱  shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '中高级保证金系统开发',
        contents: [
          {
            title: '工作内容',
            rows: [
              '你所在的团队负责银行交易系统实现和管理所有资产类别的实时、低延迟和复杂的业务功能更改，包括订单管理系统、实时风险管理系统、与世界各地的经纪商和交易所的连接、业务逻辑组件和低级交易基础设施组件。',
              '主要从事前台风险管理系统的开发，包括：',
              '交易前授权管理',
              '客户投资组合监控和流动性',
              '银行风险敞口计算',
              '实时保证金计算'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '计算机或软件工程背景',
              '精通C#',
              '具有开发服务器端系统的经验',
              '了解多线程环境开发',
              '至少从事过一个资产类别的交易/实时保证金管理系统',
              '有消息总线架构经验',
              '具备开放和协作的工作态度',
              '',
              '请将简历发送到邮箱  shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '中高级平台开发',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '你所在的团队负责银行交易系统实现和管理所有资产类别的实时、低延迟和复杂的业务功能更改，包括订单管理系统、实时风险管理系统、与世界各地的经纪商和交易所的连接、业务逻辑组件和低级交易基础设施组件',
              '主要从事前台风险管理系统的开发，包括：',
              '交易前授权管理',
              '客户投资组合监控和流动性',
              '银行风险敞口计算',
              '实时保证金计算'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '在HTML5 / JavaScript和React- Redux和Web技术（包括单页应用程序）方面拥有8年以上的专业经验',
              '具有渲染技术和编写高性能代码的经验',
              '精通ES6，CSS3',
              '具有金融知识或愿意快速了解金融行业，熟悉在线交易优先',
              '精通代码版本控制工具，例如Git / TFS',
              '担任前端开发人员3年以上的高级JS和Web技术专业经验',
              '能够参与新产品和工程的设计和开发，并应用最佳实践和工具',
              '',
              '请将简历发送到邮箱  shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '中高级接口开发',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '3+年以上C# 和 .NET 经验',
              '对服务定位器、对象生存期、容器构建和拆样等相关概念精通',
              '对 MVC ASP.NET协议、MVC 应用程序中的典型应用程序模式（区域、Html、Razor 视图、捆绑和分化）的充分了解',
              '基于 REST 的 Web 服务的系统中工作体系结构有一些经验',
              'Signal R 等流式处理技术的经验将是一个优势',
              '',
              '请将简历发送到邮箱  shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '中高级行情开发',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '从全球市场获得市场价格，包括外汇、股票、期货、债券、远期、期权',
              '将市场价格分配到交易平台，并为客户计算价格',
              '支持全球市场交易执行并提供交易图表工具'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '熟练掌握C++',
              '对多线程编程有良好的了解',
              '能够使用数据库，尤其是 MS SQL Server',
              '',
              '请将简历发送到邮箱  shtjv@saxobank.com'
            ]
          }
        ]
      }
    ]
  },
  {
    prop: 2,
    label: '设计',
    icon: require('@/assets/icon/design.png'),
    subs: [
      {
        job: '资深UI设计师',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '该岗位候选人将负责交易产品App设计',
              '参与产品需求和交互讨论，依附产品需求进行界面设计',
              '他/她将主导部分业务线视觉风格和设计规范制定并对呈现效果负责'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '全日制统招本科及以上学历，毕业于艺术类相关专业',
              '拥有3-5年UI设计经验',
              '具有业务思维，有产品意识能理解产品目标，有设计思考能力，能准确把握设计风格，善于使用各种方法解决设计问题',
              '有较好的洞察能力，注重用户体验',
              '有高度的责任心，按时/高质量完成任务，具备良好的沟通表达和组织协调能力，注重执行',
              '自驱力强，注重细节，热爱生活',
              '有金融、证券等行业经验优先',
              '需提供作品集',
              '',
              '请将简历发送到邮箱shtjv@saxobank.com'
            ]
          }
        ]
      },
    ]
  },
  {
    prop: 3,
    label: '商务',
    icon: require('@/assets/icon/business.png'),
    subs: [
      {
        job: '商务专家（数据治理专家）',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '负责公司对银行等金融行业客户数据治理解决方案的规划，参与制定市场拓展策略',
              '参与银行等金融行业客户的需求沟通，进行项目规划并形成解决方案',
              '向产品研发团队提出业务功能需求，协助数据治理产品开发与改进',
              '指导数据治理项目的实施，建设数据治理管理制度框架，制定数据标准，梳理数据资产，协助技术团队完成产品的落地实施'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '5年以上银行等金融机构数据治理咨询或数据治理平台建设实际项目经验，熟悉银行等金融机构数据治理体系',
              '具备数据治理项目管理能力，能够指导项目团队开展数据治理项目，具备准确挖掘、分析、引导客户需求的能力',
              '具备独立进行数据治理咨询的能力，包括制度框架建设、岗位职责及工作流程制定等',
              '了解先进的数据治理方法论与相关监管政策动态，熟悉数据治理工作流程与管理方法',
              '出色的方案编写能力与演示能力，熟练编写分析报告、规划建议方案等文档',
              '',
              '请将简历发送到邮箱  shtjv@saxobank.com'
            ]
          }
        ]
      }
    ]
  },
  {
    prop: 4,
    label: '项目/产品管理',
    icon: require('@/assets/icon/product.png'),
    subs: [
      {
        job: '风险平台产品经理',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '参与及协助TechJV新产品线的开发',
              '负责市场风险模型相关需求分析',
              '参与并主导需求实现讨论，包括用户交互、数据交互、模型计量结果展示等',
              '关注行业用户反馈，行业竞品动态，持续对用户需求实现进行优化'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '统招本科及以上，数学、金融及相关专业',
              '3年以上银行市场风险项目咨询或实施经验',
              '有FRM证书者优先',
              '有Algo，Adaptiv等系统的开发或实施经验优先',
              '对金融相关数据及模型，包括数据来源、格式及相关计量模型较为熟悉',
              '具有较强沟通交流、优秀文档编写能力，对行业内客户需求理解较为深入',
              '',
              '请将简历发送到邮箱shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '资管系统行业解决方案专家',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '资管系统售前支持：配合一线销售/售前，向客户提供金融行业资管系统的技术咨询、解决方案、分析规划及实施培训',
              '资管系统行业产品和方案沉淀：挖掘各种金融业态（保险，银行，证券，互金）和商业模式下对关键客户、关联业务方有价值的产品需求，产出行业产品设计，行业解决方案并有节奏进行产品项目推进和落地',
              '提供方案标准和行业赋能输出，对销售人员进行技术赋能和培训，提高销售人员方案理解和方案能力',
              '推动协同内外部、上下游团队完成POC的需求调研、方案设计、产品研发及交付实施',
              '推动金融生态伙伴的开拓，包含生态策略，生态拓展和生态赋能'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '金融硕士及以上学历，10年以上券商&基金业务工作经验，资深行业业务专家，有丰富的行业咨询或服务经验',
              '具备良好的解决方案设计能力，能够独立完成客户诉求挖掘，方案设计等工作',
              '具备一定的产品化思维和能力 ，将解决方案提炼为公司产品/服务，与产品经理协同推动产品演进',
              '具备出色的的沟通表达能力和敏锐的客户洞察力，良好的团队合作意识，沟通协调能力',
              '',
              '请将简历发送到邮箱shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '高级IT需求分析师',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '提炼和更新业务的需求，将其转化为给开发和测试人员的需求文档',
              '与架构师和业务负责人合作，找到解决业务问题或者实现业务目标的最佳解决方案',
              '熟悉相关的中国常用的运营模式、供应商应用程序和技术解决方案',
              '通过检查测试场景和主导UAT，积极配合功能的交付',
              '与业务负责人一起管理产品/项目的待办事项，确保正确的优先级、合理的结构和详细的细节记录',
              '通过检查测试场景，确保测试有效覆盖需实现的功能（必要时让用户参与）',
              '扎实的期货领域知识和经验，与中国和全球的同事分享相关信息',
              '工作中确保充分的分析和规范化，建立稳健的、有弹性空间的交易平台，技术和操作流程'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '了解交易流程、应用功能、金融产品和系统接口',
              '了解中国期货交易生命周期的流程，在特定流程有资深经验者优先',
              '较强的人际关系管理和沟通技能',
              '规范需求和项目管理能力',
              '能够将领域/行业知识应用于系统架构设计的讨论中',
              '对IT各方面具备一定概念：如架构、硬件、软件和系统接口',
              '',
              '请将简历发送到邮箱shtjv@saxobank.com'
            ]
          }
        ]
      },
    ]
  },
  {
    prop: 5,
    label: '其它',
    icon: require('@/assets/icon/public.png'),
    subs: [
      {
        job: '法务经理',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆/上海'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '为公司提供日常及专项法律意见、支持和服务',
              '完善优化公司的法务框架、规章制度以最大化帮助公司实现业务目标',
              '参与与外部客户的谈判、会议，保护公司利益',
              '建议和辅助公司进行权益投资、募资项目以及其他在中国地区的重要投资和商务事宜',
              '确认、规避/最小化、对应法律和合规风险',
              '为公司内控提供建议，负责准备股东/董事会决议和年度内审',
              '管理日常的IP和品牌保护相关事宜',
              '管理律所等供应商，协调内外部律师'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '法学学士及以上学历，必须通过中国司法考试',
              '5 年以上金融相关行业法务经验',
              '自我驱动、结果导向、高效沟通',
              '能够同时管理多项任务并在规定的同一时间节点交付',
              '英语书面、口语流利',
              '',
              '请将简历发送到邮箱shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: '社群运营',
        contents: [
          {
            title: '工作地点',
            rows: [
              '重庆'
            ]
          },
          {
            title: '工作内容',
            rows: [
              '负责策划线上活动，维护社群用户',
              '结合用户答疑，挖掘用户需求，协助促成用户的转化',
              '梳理社群运营体系，利用数据分析工具对过程监控分析，对转化效果负责'
            ]
          },
          {
            title: '任职要求',
            rows: [
              '本科及以上学历，专业不限，经济、金融类专业者尤佳',
              '有社群活动策划，能够独立分析数据，策划过优秀活动案例者优先',
              '同时管理过多个社群，熟悉常用社群营销工具，对社群中常见问题有系统化解决方案',
              '善于沟通，具有严谨的逻辑思维和敏锐的洞察力，自我驱动力强，执行力强，工作细致，有较强的责任心和服务意识',
              '',
              '请将简历发送到邮箱shtjv@saxobank.com'
            ]
          }
        ]
      }
    ]
  }],


  join: {
    filter: '筛选',
    clear: '清除',
    searching: "搜索职位",
    searchBtn: "搜索",
    posiType: "职位类型",
    city: "城市",
    type: "招聘类型",
    empty: "暂无相关职位!",
  }
}